var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"portal-button",on:{"click":function($event){$event.preventDefault();return _vm.create.apply(null, arguments)}}},[_vm._v("Create offers")])])}
var staticRenderFns = []

export { render, staticRenderFns }